import { IconProps } from '@/types/icon';

export type IconeSetaType = {
  direcao?: 'direita' | 'esquerda' | 'baixo' | 'cima';
};
export type IconSetaProps = IconProps & IconeSetaType;

export function IconeSeta({
  size,
  color,
  direcao,
  style,
  ...props
}: IconSetaProps) {
  const rotacao = {
    direita: '0',
    esquerda: '180',
    cima: '-90',
    baixo: '90',
  };
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="seta"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      color={color}
      width={size}
      height={size}
      style={{
        transform: `rotate(${rotacao[direcao ?? 'direita']}deg)`,
        ...style,
      }}
      {...props}
    >
      <path
        d="M9.70498 6L8.29498 7.41L12.875 12L8.29498 16.59L9.70498 18L15.705 12L9.70498 6Z"
        fill="currentColor"
      />
    </svg>
  );
}
